const cleanUpForm = (formData) => {
  if (formData['otherIndustry']) {
    formData['industry'] = formData['otherIndustry'];
  }
  if (formData['org_department']) {
    formData['department'] = formData['org_department'];
  }
  if (formData['org_title']) {
    formData['title'] = formData['org_title'];
  }
  const cleanUpList = [
    'confirmPassword',
    'universityRole',
    'otherIndustry',
    'org_department',
    'org_title',
  ];
  cleanUpList.forEach((item) => {
    delete formData[item];
  });
  for (var propName in formData) {
    if (
      formData[propName] === false ||
      formData[propName] === null ||
      formData[propName] === undefined ||
      formData[propName] === ''
    ) {
      delete formData[propName];
    }
  }
  return formData;
};

export default cleanUpForm;
